module.exports = __webpack_public_path__ + "static/media/withdraw-icon.a851da06.svg";